/* eslint-disable @typescript-eslint/no-use-before-define */
import {
    Action,
    ActionReducerMap,
    createFeatureSelector,
    createSelector,
    StoreModule,
} from '@ngrx/store';
import { SelectedItems } from 'src/app/models/selectedItems';
import {
    SetSelectedItems,
    ToggleCollection,
    ToggleGeofence,
    TogglePlannedRide,
    ToggleTrackedRide,
    ToggleWaypoint,
    UserContentAction,
} from './rides-places.actions';

export interface UserContentState {
    selectedItems: SelectedItems;
}

export const reducerMap: ActionReducerMap<UserContentState> = {
    selectedItems: selectedItemsReducer,
};

export const selectUserContentState =
    createFeatureSelector<UserContentState>('userContent');
export const selectSelectedItems = createSelector(
    selectUserContentState,
    (state) => state.selectedItems
);

export const userContentStoreModule = StoreModule.forFeature(
    'userContent',
    reducerMap
);

export function selectedItemsReducer(
    state = new SelectedItems(),
    action: Action
): SelectedItems {
    switch (action.type) {
        case UserContentAction.setSelectedItems:
            return (action as SetSelectedItems).selectedItems.clone();

        case UserContentAction.clearSelectedUserContentIds:
            return new SelectedItems();

        case UserContentAction.toggleCollection:
            return state.toggleCollection((action as ToggleCollection).item);

        case UserContentAction.togglePlannedRide:
            return state.togglePlannedRide((action as TogglePlannedRide).item);

        case UserContentAction.toggleWaypoint:
            return state.toggleWaypoint((action as ToggleWaypoint).item);

        case UserContentAction.toggleTrackedRide:
            return state.toggleTrackedRide((action as ToggleTrackedRide).item);

        case UserContentAction.toggleGeofence:
            return state.toggleGeofence((action as ToggleGeofence).item);

        default:
            return state;
    }
}
